"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var IconButton_1 = require("@material-ui/core/IconButton");

var TableCell_1 = require("@material-ui/core/TableCell");

var TableSortLabel_1 = require("@material-ui/core/TableSortLabel");

var Tooltip_1 = require("@material-ui/core/Tooltip");

var FilterList_1 = require("@material-ui/icons/FilterList");

var React = require("react");

var tubular_common_1 = require("tubular-common");

exports.GridHeaderCell = function (_a) {
  var column = _a.column,
      sortColumn = _a.sortColumn,
      setActiveColumn = _a.setActiveColumn;

  var sort = function sort() {
    return sortColumn(column.Name);
  };

  var handleClick = function handleClick(e) {
    return setActiveColumn(column, e);
  };

  var direction = column.SortDirection === tubular_common_1.ColumnSortDirection.ASCENDING || column.SortDirection === tubular_common_1.ColumnSortDirection.NONE ? 'asc' : 'desc';
  var render = column.Sortable ? React.createElement(Tooltip_1["default"], {
    title: 'Click to sort. Press Ctrl to sort by multiple columns',
    placement: 'bottom-start',
    enterDelay: 300
  }, React.createElement(TableSortLabel_1["default"], {
    onClick: sort,
    direction: direction,
    active: column.SortDirection !== tubular_common_1.ColumnSortDirection.NONE
  }, column.Label)) : column.Label;
  var filter = column.Filterable && React.createElement(IconButton_1["default"], {
    id: column.Name,
    onClick: handleClick
  }, React.createElement(FilterList_1["default"], {
    color: column.Filter.HasFilter && column.Filter.Operator !== tubular_common_1.CompareOperators.NONE ? 'action' : 'disabled'
  }));
  return React.createElement(TableCell_1["default"], {
    key: column.Label,
    padding: column.Label === '' ? 'none' : 'default'
  }, render, filter);
};